import { createFileRoute, Link } from "@tanstack/react-router";

export const Route = createFileRoute("/terms")({
  head: () => ({
    meta: [
      { title: "Điều khoản dịch vụ — Ezyclass" },
      { name: "description", content: "Điều khoản sử dụng dịch vụ Ezyclass — phần mềm quản lý trung tâm học tập." },
      { property: "og:title", content: "Điều khoản dịch vụ — Ezyclass" },
      { property: "og:description", content: "Điều khoản sử dụng dịch vụ Ezyclass." },
    ],
    links: [{ rel: "canonical", href: "https://ezyclass.com/terms" }],
  }),
  component: TermsPage,
});

function TermsPage() {
  return (
    <main className="max-w-3xl mx-auto px-5 md:px-8 py-16 prose prose-slate">
      <Link to="/" className="text-sm text-blue-600 hover:underline no-underline">← Về trang chủ</Link>
      <h1 className="font-display">Điều khoản dịch vụ</h1>
      <p className="text-sm text-slate-500">Cập nhật lần cuối: 30/05/2026</p>

      <h2>1. Bên cung cấp dịch vụ</h2>
      <p>
        Dịch vụ Ezyclass (“Dịch vụ”, “Chúng tôi”) được cung cấp bởi <strong>Ezyclass</strong>
        (“Bên bán”). Bằng việc đăng ký tài khoản hoặc sử dụng Dịch vụ, bạn (“Người dùng”) đồng ý
        chịu sự ràng buộc bởi các điều khoản này.
      </p>

      <h2>2. Mô tả dịch vụ</h2>
      <p>
        Ezyclass là phần mềm quản lý trung tâm học tập trên nền tảng web, bao gồm: quản lý lớp học,
        học viên, giáo viên, lịch dạy, điểm danh, bài tập, thông báo và báo cáo. Dịch vụ được cung
        cấp theo các gói thuê bao có giới hạn tính năng và số lượng khác nhau.
      </p>

      <h2>3. Tài khoản & trách nhiệm người dùng</h2>
      <ul>
        <li>Bạn phải đủ tuổi theo pháp luật hoặc có thẩm quyền đại diện cho tổ chức của mình.</li>
        <li>Bạn có trách nhiệm bảo mật thông tin đăng nhập và mọi hoạt động trong tài khoản.</li>
        <li>Bạn cam kết cung cấp thông tin chính xác và cập nhật khi cần.</li>
      </ul>

      <h2>4. Sử dụng đúng mục đích</h2>
      <p>Bạn cam kết không sử dụng Dịch vụ để:</p>
      <ul>
        <li>Vi phạm pháp luật Việt Nam hoặc quốc tế.</li>
        <li>Gửi thư rác, lừa đảo, hoặc xâm phạm quyền riêng tư của người khác.</li>
        <li>Xâm phạm quyền sở hữu trí tuệ của bất kỳ bên nào.</li>
        <li>Phá hoại, dò quét, cài mã độc hoặc can thiệp vào hạ tầng Dịch vụ.</li>
        <li>Sao chép, bán lại, đảo ngược kỹ thuật hoặc vượt giới hạn kỹ thuật của Dịch vụ.</li>
      </ul>

      <h2>5. Quyền sở hữu trí tuệ</h2>
      <p>
        Ezyclass và toàn bộ phần mềm, mã nguồn, tài liệu, thương hiệu, giao diện thuộc sở hữu của
        Bên bán. Bạn được cấp quyền sử dụng có giới hạn, không độc quyền, không chuyển nhượng trong
        phạm vi gói thuê bao đã chọn.
      </p>

      <h2>6. Nội dung của người dùng</h2>
      <p>
        Bạn giữ quyền sở hữu đối với dữ liệu mà bạn nhập vào Dịch vụ (thông tin học viên, bài tập,
        v.v.). Bạn cấp cho chúng tôi quyền giới hạn để lưu trữ, xử lý dữ liệu đó nhằm cung cấp
        Dịch vụ cho bạn.
      </p>

      <h2>7. Thanh toán &amp; chu kỳ thuê bao</h2>
      <p>
        Quá trình thanh toán được thực hiện thông qua đối tác bán lẻ trực tuyến{" "}
        <strong>PayOS</strong>. PayOS là <em>Merchant of Record</em> (Bên bán hàng đại
        diện) cho mọi đơn hàng của chúng tôi, xử lý thanh toán, hóa đơn, thuế, hủy gói và hoàn
        tiền theo các điều khoản tại{" "}
        <a href="https://payos.vn" target="_blank" rel="noopener noreferrer">
          Điều khoản PayOS
        </a>
        .
      </p>
      <p>
        Gói thuê bao tự động gia hạn vào cuối mỗi chu kỳ (tháng hoặc năm) cho đến khi bạn hủy.
        Khi hủy, bạn vẫn được giữ quyền truy cập đến hết chu kỳ đã trả tiền.
      </p>

      <h2>8. Thanh toán &amp; hủy gói</h2>
      <p>
        Bạn có thể hủy gói bất kỳ lúc nào trong trang Cài đặt — Thanh toán. Khi hủy, bạn vẫn giữ
        quyền truy cập đến hết chu kỳ đã thanh toán; chu kỳ sau sẽ không gia hạn tự động.
      </p>

      <h2>9. Tạm ngưng &amp; chấm dứt</h2>
      <p>
        Chúng tôi có quyền tạm ngưng hoặc chấm dứt tài khoản nếu phát hiện: vi phạm nghiêm trọng
        điều khoản, không thanh toán, rủi ro bảo mật / gian lận, hoặc vi phạm chính sách lặp lại.
        Khi tài khoản chấm dứt, bạn có thời hạn 30 ngày để xuất dữ liệu trước khi dữ liệu bị xóa.
      </p>

      <h2>10. Cam kết về dịch vụ &amp; trách nhiệm</h2>
      <p>
        Dịch vụ được cung cấp “nguyên trạng”. Chúng tôi không cam kết Dịch vụ luôn không gián
        đoạn hoặc không có lỗi. Trong giới hạn tối đa pháp luật cho phép, chúng tôi loại trừ mọi
        bảo đảm ngầm định và giới hạn trách nhiệm tổng hợp ở mức phí bạn đã trả cho 12 tháng
        gần nhất.
      </p>

      <h2>11. Sửa đổi điều khoản</h2>
      <p>
        Chúng tôi có thể cập nhật điều khoản này. Phiên bản mới sẽ được đăng tại trang này và có
        hiệu lực kể từ ngày cập nhật. Việc tiếp tục sử dụng Dịch vụ sau ngày cập nhật được coi là
        bạn đồng ý với phiên bản mới.
      </p>

      <h2>12. Luật áp dụng</h2>
      <p>
        Điều khoản này được điều chỉnh bởi pháp luật Việt Nam. Mọi tranh chấp sẽ được giải quyết
        tại tòa án có thẩm quyền tại Việt Nam.
      </p>

      <h2>13. Liên hệ</h2>
      <p>
        Mọi câu hỏi vui lòng gửi về <a href="mailto:contact@ezyclass.com">contact@ezyclass.com</a>.
      </p>
    </main>
  );
}
